import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { randuBlogService } from "../services/api";

const BlogRanduSettingsPage = () => {
  const [settings, setSettings] = useState(null);
  const [gemini_api_key, setKey] = useState("");
  const [gemini_model, setModel] = useState("gemini-2.0-flash");
  const [gemini_blog_system_prompt, setPrompt] = useState("");
  const [gemini_default_publish_ai, setPub] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      const res = await randuBlogService.getSettings();
      if (res.success && res.settings) {
        setSettings(res.settings);
        setModel(res.settings.gemini_model || "gemini-2.0-flash");
        setPrompt(res.settings.gemini_blog_system_prompt || "");
        setPub(!!res.settings.gemini_default_publish_ai);
      }
    })();
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const payload = {
        gemini_model,
        gemini_blog_system_prompt,
        gemini_default_publish_ai: gemini_default_publish_ai,
      };
      if (gemini_api_key.trim()) payload.gemini_api_key = gemini_api_key.trim();
      const res = await randuBlogService.saveSettings(payload);
      alert(res.success ? "Kaydedildi" : res.message || "Hata");
      setKey("");
      const r2 = await randuBlogService.getSettings();
      if (r2.success) setSettings(r2.settings);
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Randu.app Blog — Gemini ayarları" />
      <div className="card">
        <div className="card-body">
          {settings && (
            <p className="small text-muted">
              API anahtarı: {settings.gemini_api_key_set ? `Kayıtlı (${settings.gemini_api_key_masked})` : "Kayıtlı değil"}
            </p>
          )}
          <div className="mb-3">
            <label className="form-label">Yeni Gemini API anahtarı (değiştirmek için doldurun)</label>
            <input type="password" className="form-control" value={gemini_api_key} onChange={(e) => setKey(e.target.value)} />
          </div>
          <div className="mb-3">
            <label className="form-label">Model</label>
            <input className="form-control" value={gemini_model} onChange={(e) => setModel(e.target.value)} />
          </div>
          <div className="mb-3">
            <label className="form-label">Ek sistem promptu (varsayılanın üstüne eklenir)</label>
            <textarea className="form-control" rows={8} value={gemini_blog_system_prompt} onChange={(e) => setPrompt(e.target.value)} />
          </div>
          <div className="form-check mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="pubai"
              checked={gemini_default_publish_ai}
              onChange={(e) => setPub(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="pubai">
              AI ile üretilen yazılar varsayılan olarak yayında gelsin (kapalı = taslak)
            </label>
          </div>
          {settings?.default_prompt_hint && (
            <div className="alert alert-light small">
              <strong>Kod içi varsayılan özet:</strong> {settings.default_prompt_hint}
            </div>
          )}
          <button type="button" className="btn btn-primary" disabled={saving} onClick={save}>
            {saving ? "Kaydediliyor…" : "Kaydet"}
          </button>
        </div>
      </div>
    </MasterLayout>
  );
};

export default BlogRanduSettingsPage;
